import { render, staticRenderFns } from "./BookStatistics.vue?vue&type=template&id=0e135348&scoped=true"
import script from "./BookStatistics.vue?vue&type=script&lang=js"
export * from "./BookStatistics.vue?vue&type=script&lang=js"
import style0 from "./BookStatistics.vue?vue&type=style&index=0&id=0e135348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e135348",
  null
  
)

export default component.exports